(function(angular){
	'use strict';

	angular
		.module('homeModule')
		.directive('eDirectInvestingWidget', [
			'$interval', 
			'STATIC_BASE_PATH',
			eDirectInvestingWidgetFunction
		]);

	function eDirectInvestingWidgetFunction(
		$interval,
		STATIC_BASE_PATH) {
		return {
			replace: true,
			restrict: 'E',
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/edirect-investing-widget/edirect-investing-widget.html',
			link: function($scope, $attrs, $elem) {
				
				$scope.segments = [{
					y: 0.055,
					color: "#3FBFFF"
				},{
					y: 0.208,
					color: "#39E68F"
				},{
					y: 0.057,
					color: "#ACE639"
				},{
					y: 0.363,
					color: "#FFC533"
				},{
					y: 0.219,
					color: "#FFAF40"
				},{
					y: 0.094,
					color: "#FF884C"
				}];
				
				$scope.segmentRadius = function($index) {
					return 40 - ($index * 6);
				};
				
				$scope.segmentStyle = function($index) {
					
					var segment = $scope.segments[$index];
					var circumference = Math.PI * 2 * $scope.segmentRadius($index);

					var startPercentage = function() {
						var percentage = 0;
						angular.forEach($scope.segments, function(segmentInArray, indexOfArray) {
							if(indexOfArray < $index) {
								percentage += segmentInArray.y;
							}
						});
						return percentage;
					};

					var dashArray = function() {
						if(segment.shrink) {
							return circumference * 0.25 + " " + circumference * 0.75;
						} else {
							return circumference * 0.75 + " " + circumference * 0.25;
						}
					};
					
					return {
						stroke: segment.color,
						strokeDasharray: dashArray(),
						strokeDashoffset: startPercentage() * circumference,
						strokeWidth: 2,
						transformOrigin: '50% 50%',
						transition: '10s all linear'	
					};
				};
				
				$interval(function() {
					var targetIndex = Math.floor(Math.random() * 6);
					var targetSegment = $scope.segments[targetIndex];
					
					if(typeof(targetSegment.shrink) === 'undefined') {
						targetSegment.shrink = true;
					} else if(!targetSegment.shrink) {
						targetSegment.shrink = true;
					} else {
						targetSegment.shrink = false;
					}
					
				}, 10000 / 6);
			}
		};
	}
})(window.angular);